import React from 'react';

export const SelectIcon = ({
  width = 28,
  height = 28,
  color = '#fff',
  stroke = '#000',
}) => (
  <svg
    width={width}
    height={height}
    fill={color}
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0793 4.81365L22.2543 22.302C22.6509 23.2703 21.6593 24.2387 20.7026 23.807L14.4726 21.0537C14.1693 20.9253 13.8309 20.9253 13.5276 21.0537L7.2976 23.807C6.34094 24.227 5.34927 23.2703 5.74594 22.302L12.9209 4.81365C13.3059 3.84532 14.6826 3.84532 15.0793 4.81365Z"
      stroke={stroke}
      strokeWidth="2"
    />
  </svg>
);
